export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_URL || "https://staging-chatbots.innova.com/api/innova/v2.0",
    AUTH: "Basic " + (process.env.REACT_APP_API_AUTH || "L3czLSVJeFs4OzFoby9EOENYJjw="),
    TIMEOUT: 5000,
} as const;

export const LOCAL_STORAGE_TTL = 60; // seconds

export const AUTOMOTIVE_SITE = {
    IS_AUTO: process.env.REACT_APP_IS_AUTOMOTIVE_SITE ? process.env.REACT_APP_IS_AUTOMOTIVE_SITE === "true" : false
} as const
